/** Trusted-shell pilot feedback. Context is diagnostic, never authorization. */
export const FEEDBACK_PAGES = ['classes', 'build', 'apps', 'resources', 'library', 'activity', 'district'] as const;
export type FeedbackPage = typeof FEEDBACK_PAGES[number];
export type FeedbackStatus = 'new' | 'investigating' | 'fixed';
export interface FeedbackContext {
  page: FeedbackPage;
  buildId?: string;
  appRef?: string;
  browser: 'Edge' | 'Chrome' | 'Firefox' | 'Safari' | 'Other';
  viewport: { width: number; height: number };
}
export interface PilotFeedbackInput {
  requestKey: string;
  message: string;
  context: FeedbackContext;
}
export interface PilotFeedbackReport {
  id: string;
  message: string;
  context: FeedbackContext;
  status: FeedbackStatus;
  createdAt: string;
  buildId: string | null;
  sourceSha256: string | null;
}
